export enum EmpresaStatusDocumentacaoEnum {
    PENDENTE = 'PENDENTE',
    AGUARDANDO_APROVACAO = 'AGUARDANDO_APROVACAO',
    APROVADO = 'APROVADO',
    RECUSADO = 'RECUSADO'
}
